module.exports = __webpack_public_path__ + "img/check_1.055a5d04.png";